import React from "react";
import { GenericVerification } from "../slices/GenericVerification";
import { CriminalReport } from "../slices/CriminalReport";

export const VerificationSwitch = ({ verification }) => {
  switch (verification.name) {
    case "criminal_report":
      return <CriminalReport verification={verification} />;
    default:
      return <GenericVerification verification={verification} />;
  }
};
